var _style, _circle, _path, _circle2, _path2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBulletPoints = function SvgBulletPoints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "bullet-points_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".bullet-points_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 4.5,
    r: 2,
    className: "bullet-points_svg__st0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.5h15",
    className: "bullet-points_svg__st0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 12.5,
    r: 2,
    className: "bullet-points_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.5h15",
    className: "bullet-points_svg__st0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 20.5,
    r: 2,
    className: "bullet-points_svg__st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 20.5h15",
    className: "bullet-points_svg__st0"
  })));
};
export default SvgBulletPoints;